import { render, staticRenderFns } from "./UserStatusChanged.vue?vue&type=template&id=f5d3d814&scoped=true"
import script from "./UserStatusChanged.vue?vue&type=script&lang=js"
export * from "./UserStatusChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d3d814",
  null
  
)

export default component.exports